const defaultKey = 'state';

export const loadState = (key = null) => {
    try {
        if (window.envBooqadmin.lastModified !== undefined && window.envBooqadmin.lastModified > 0 && localStorage.getItem('lastModified') !== window.envBooqadmin.lastModified) {
            localStorage.setItem('lastModified', window.envBooqadmin.lastModified);
            return undefined;
        }
        const serializedState = localStorage.getItem(key || defaultKey);
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (e) {
        return undefined;
    }
}

export const saveState = (state, key = null) => {
    try {
        const serializedState = JSON.stringify(state);
        const serializedOldState = localStorage.getItem(key || defaultKey);
        if (serializedOldState !== serializedState) {
            localStorage.setItem(key || defaultKey, serializedState);
        }
    } catch (e) {
        console.error(e);
    }
}

export const subscribe = (cb, key = null) => {
    key = (key || defaultKey);
    window.addEventListener('storage', (e) => {
        //console.log(`Key Changed: ${e.key}`);
        //console.log(`New Value: ${e.newValue}`);
        if (e.key === key) {
            cb(JSON.parse(e.newValue), key, e);
        }
    });
}